(function() {
    	/**
	 * Render Privacy page
	 * @param {object} props - The Routing context
	 * @returns {object} Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderPrivacyPage = function(props) {
		var $el = $('<div />');
		var params = {
			page: null,
			cookie: null
		};
		var model = {
			element: $('<div />'),
			template: 'templates/privacy.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				lang: WebBaseAprovLV.lang,
				cookie: null
			}
		};
		return WebBaseAprovLV.renderGenericPage(props).then(function(modelGeneric) {
			model.data = $.extend({}, modelGeneric.data, model.data);
			params.page = modelGeneric;
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).then(function(modelPrivacy) {
			$('#content .content_section').append(modelPrivacy.element);
			return modelPrivacy || {};
		}).promise();
	};

})();
